export const CrewJoinerTexts = {
  JoiningSuccessful: "Beitritt erfolgreich",
} as const;
